<template>
  <div class="carousel">
    <div class="title">
      <img src="../assets/img/new/title_3.png" />
    </div>
    <div class="content">
      <el-carousel
        ref="eventsCarousel"
        class="richEventsSlide"
        style="width: 90%; margin: 5% 5% 1% 5%"
        indicator-position="outside"
        :height="imgDisplayHeight + 'px'"
      >
        <el-carousel-item v-for="item in imgArray" :key="item">
          <div>
            <img
              ref="imgDisplayHeight"
              class="carouselImg"
              :src="item"
              @load="imgLoadHandler"
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Util from "./util";

export default {
  name: "rich-events",
  data() {
    return {
      imgDisplayHeight: "",
      imgArray: [
        // require("../assets/carousel-2/1.jpg"),
        require("../assets/carousel-2/2.jpg"),
        require("../assets/carousel-2/3.jpg"),
        require("../assets/carousel-2/4.jpg"),
        require("../assets/carousel-2/5.jpg"),
        require("../assets/carousel-2/6.jpg"),
      ],
    };
  },
  mounted() {
    this.imgLoadHandler();
    window.addEventListener(
      "resize",
      () => {
        this.imgDisplayHeight = this.$refs.imgDisplayHeight[0].height;
        this.imgLoadHandler();
      },
      false
    );
    Util.carouselSlideHandler(
      ".richEventsSlide .el-carousel__container",
      this.$refs.eventsCarousel
    );
  },
  methods: {
    imgLoadHandler() {
      this.$nextTick(() => {
        this.imgDisplayHeight = this.$refs.imgDisplayHeight[0].height;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.carousel {
  margin: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    img {
      width: 100%;
    }
  }

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("../assets/img/new/bg_2.png") no-repeat center;
    background-size: 100% 100%;
    /deep/ .el-carousel__button {
      width: 3vw;
      height: 3vw;
      border-radius: 3vw;
      border: 0.5vw solid rgb(28, 3, 12);
    }
    /deep/ .el-carousel__container {
      border-style: solid;
      border-width: 10px;
      border-color: #2e0609;
      border-radius: 10px;
    }
    /deep/ .el-carousel__indicator--horizontal {
      display: inline-block;
    }
    /deep/ .el-carousel__indicators--outside button {
      background-color: rgb(166, 0, 46);
      opacity: 0.24;
    }
    /deep/ .el-carousel__indicator.is-active button {
      background-color: rgb(240, 109, 10);
      opacity: 1;
    }
    .carouselImg {
      width: 100%;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rich-events.vue